import React from "react";
import { useTranslation } from "react-i18next";
import SeoHead from "@/components/SeoHead";
import PageShell from "@/components/PageShell";
import PageBanner from "@/components/PageBanner";
import CaffeOnTheRoad from "@/components/landing/CaffeOnTheRoad";

const BANNER = "/road-banner.jpg";

const OnTheRoad = () => {
  const { t } = useTranslation();
  return (
    <PageShell>
      <SeoHead pageKey="road" image={BANNER} />
      <PageBanner
        eyebrow={t("road.banner.eyebrow")}
        title={t("road.banner.title")}
        subtitle={t("road.banner.subtitle")}
        image={BANNER}
      />
      <CaffeOnTheRoad />
    </PageShell>
  );
};

export default OnTheRoad;
